import { render } from "./WordDetail.vue?vue&type=template&id=75ab2243&scoped=true"
import script from "./WordDetail.vue?vue&type=script&lang=js"
export * from "./WordDetail.vue?vue&type=script&lang=js"

import "./WordDetail.vue?vue&type=style&index=0&id=75ab2243&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ab2243"]])

export default __exports__